import React from 'react';
export function Garantia() {
  return <section className="py-[34px] px-5 bg-brand-black" data-id="element-84">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-85">
        <div className="max-w-[680px] mx-auto bg-gradient-to-br from-[#0f0f0f] to-[#0b1200] border border-brand-gold rounded-[14px] p-[28px_28px] text-center sm:p-[22px_18px]" data-id="element-86">
          <span className="text-[4rem] mb-[14px] block leading-none" data-id="element-87">🛡️</span>
          <h2 className="font-montserrat font-black text-[clamp(1.3rem,3.5vw,2rem)] text-brand-gold uppercase mb-4" data-id="element-88">
            Garantía Total de 30 Días
          </h2>
          <p className="text-base text-brand-gray-text leading-[1.85]" data-id="element-89">
            Aplica el sistema durante 30 días completos. Si seguís el plan y no
            ves una diferencia real en tu control, tu resistencia y tu confianza
            — te devolvemos el{' '}
            <strong className="text-brand-gold font-bold" data-id="element-90">
              100% de tu inversión
            </strong>
            . Sin preguntas. Sin formularios. Sin vueltas. El riesgo es
            completamente nuestro porque creemos en los resultados.
          </p>
        </div>
      </div>
    </section>;
}